import React from 'react';
import { useIntl } from 'react-intl';
import { TypedMemo } from '../../common/types';
import { useDirectedVideoContext } from '../DirectedVideoContext';
import { castMessages } from '../messages/castMessages';
import { howMadeMessages as messages } from '../messages/howMadeMessages';
import { CAST_ROLE_MESSAGES } from '../steps/castRoleMessages';
import { DIRECTED_STEP_NAMES } from '../shell/DirectedStepper';
import { useDirectedCastNames } from '../useDirectedCastNames';
import { HowMadeSection } from './HowMadeSection';
/* eslint-disable css-modules/no-unused-class -- one stylesheet for "How it was made"; each part uses its own slice of it */
import styles from './HowMade.module.scss';
/* eslint-enable css-modules/no-unused-class */

/** Step 1 of "How it was made" (design l1): the cast pictures with their names and roles. */
const HowMadeCastComponent: React.FC = () => {
  const intl = useIntl();
  const { video } = useDirectedVideoContext();
  const { names } = useDirectedCastNames();
  const generated = video.cast.filter((entry) => entry.generated).length;
  return (
    <HowMadeSection
      step="cast"
      eyebrow={intl.formatMessage(messages.stepEyebrow, {
        number: 1,
        name: intl.formatMessage(DIRECTED_STEP_NAMES.cast),
      })}
      title={intl.formatMessage(messages.castTitle, { count: video.cast.length })}
      text={
        video.cast.length === 0
          ? intl.formatMessage(messages.castNone)
          : intl.formatMessage(messages.castText, { count: generated })
      }
    >
      {video.cast.length > 0 && (
        <ul className={styles.cast}>
          {video.cast.map((entry) => {
            const name = names.get(entry.id) ?? entry.label;
            return (
              <li key={entry.id} className={styles.castCard}>
                <div className={styles.castPicture}>
                  {entry.url !== '' && <img src={entry.url} alt={name} loading="lazy" />}
                  {entry.generated && <span className={styles.aiTag}>{intl.formatMessage(castMessages.madeByAi)}</span>}
                </div>
                <div className={styles.castBody}>
                  <span className={styles.castName}>{name}</span>
                  <span className={styles.castRole}>{intl.formatMessage(CAST_ROLE_MESSAGES[entry.role])}</span>
                </div>
              </li>
            );
          })}
        </ul>
      )}
    </HowMadeSection>
  );
};

export const HowMadeCast = TypedMemo(HowMadeCastComponent);
